import { type FC } from "react";
import { useTransitionWithQuery } from "../../hooks/useTransitionWithQuery";
import { SpButtons } from "./uiParts/SpButtons";
import { type ButtonsProps, type JobEntryBoxProps } from "./types";
import { TelInformation } from "../TelInformation";
import { PcButtons } from "./uiParts/PcButtons";
import * as styles from "./styles.css";

export const CassetteActionsWithDetail: FC<JobEntryBoxProps> = ({
  isLoggedIn,
  hasKeeped,
  hasEntried,
  scoutForWork,
  workCode,
  enterableFlag,
  detailUrl,
  entryUrl,
  scoutEntryUrl,
  bookmarkUrl,
  queryString,
  clientShopIdQuery,
  showTelCounsellingButton,
  isSp,
  telNumber,
  keepTracking,
  detailTracking,
  entryTracking,
  scoutTracking,
}) => {
  const { handleClickLink } = useTransitionWithQuery();

  // キープボタンを表示するかどうか
  const showKeepButton = !isLoggedIn || (!hasEntried && !scoutForWork);

  // キープボタンの query を組み立て
  const keepQuery = [queryString, clientShopIdQuery].filter(Boolean).join("&") || undefined;

  // 電話応募情報を表示するかどうか
  const showTelInformation = showTelCounsellingButton && enterableFlag && !isSp;

  // SP用の求人番号表示
  const showSpWorkNumber = showTelCounsellingButton && enterableFlag && isSp;

  const Buttons: ButtonsProps = {
    showKeepButton,
    keepFormProps: {
      url: bookmarkUrl,
      query: keepQuery,
      gaAction: hasKeeped ? keepTracking.releaseGaAction : keepTracking.addGaAction,
      gaLabel: keepTracking.gaLabel,
      firebaseAction: hasKeeped
        ? keepTracking.releaseFirebaseAction
        : keepTracking.addFirebaseAction,
      workCode,
      hasKeeped,
    },
    detailLinkProps: {
      href: detailUrl,
      gaAction: detailTracking.gaAction,
      gaLabel: detailTracking.gaLabel,
      queryString,
      appierAction: detailTracking.appierAction,
    },
    entryButtonSectionProps: {
      hasEntried,
      scoutForWork,
      enterableFlag,
      entryUrl,
      scoutEntryUrl,
      workCode,
      entryTracking,
      scoutTracking,
      queryString,
    },
    onClickLink: handleClickLink,
  };

  return (
    <div className={styles.container}>
      {/* html構造は共通だが、デザイン上の表示パターンが複雑なためコンポーネントを分けている */}
      {isSp ? (
        <SpButtons {...Buttons} />
      ) : (
        <div className={styles.buttonsItem}>
          <PcButtons {...Buttons} />
        </div>
      )}
      {showTelInformation && (
        <TelInformation
          workCode={workCode}
          telNumberContent={{
            telNumber: telNumber || "",
            isShowTellButton: true,
          }}
        />
      )}
      {showSpWorkNumber && (
        <p className={styles.spWorkNumberArea}>
          求人番号：<b className={styles.spWorkNumber}>{workCode}</b>
        </p>
      )}
    </div>
  );
};
